export interface DesignationUser {
  name: string;
  type: string;
  id?: number;
}

export interface DesignationRole {
  id: number;
  name: string;
}

export interface DesignationOrgUnit {
  name: string;
  type: string;
  id?: string | number;
}

export const userCollectionComparator = (
  valueA: DesignationUser | null | undefined,
  valueB: DesignationUser | null | undefined
): number => {
  // Handle null/undefined cases
  const nameA = valueA?.name?.toLowerCase() || '';
  const nameB = valueB?.name?.toLowerCase() || '';

  // Standard string comparison
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

export const rolesComparator = (
  valueA: DesignationRole[] | null | undefined,
  valueB: DesignationRole[] | null | undefined
): number => {
  // Handle null/undefined or empty arrays
  const firstRoleNameA = valueA?.[0]?.name?.toLowerCase() || '';
  const firstRoleNameB = valueB?.[0]?.name?.toLowerCase() || '';

  // Standard string comparison based on first role name
  if (firstRoleNameA < firstRoleNameB) return -1;
  if (firstRoleNameA > firstRoleNameB) return 1;
  return 0;
};

export const orgUnitComparator = (
  valueA: DesignationOrgUnit | null | undefined,
  valueB: DesignationOrgUnit | null | undefined
): number => {
  // Handle null/undefined cases
  const nameA = valueA?.name?.toLowerCase() || '';
  const nameB = valueB?.name?.toLowerCase() || '';

  // Standard string comparison
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};
